<a [routerLink]="[href]" [queryParams]="params" [class.active]="isActive()">{{text}}
  <span *ngIf="spanValue" [class.non-zero]="spanValue !== 0">{{spanValue}}</span></a>
